function Footer() {
    return (
      <footer className="bg-dark text-white text-center py-3">
        <p>© 2025 Case Trail</p>
      </footer>
    );
  }
  
  export default Footer;